/* 예제 배치 순서 — 묶음번호(order_group) + 예제번호(order_index) 순수 로직.
   표기 = "묶음-번호"(1-1, 1-2, 2-1…). 정렬 = (group asc, index asc), 미지정은 뒤(업로드 역순).
   삽입 규칙(g-i 부여): 대상 묶음 g 안에서 index ≥ i 인 것만 +1 캐스케이드, 대상이 i 차지.
   다른 묶음은 불변. 대상이 다른 묶음서 왔으면 옛 묶음만 1..N 재압축. (순수 — 테스트 가능) */

/* meta(또는 example) → {group, index} | null. extras.order_group/index 우선, 상위 필드 폴백. */
export function getOrder(m) {
  if (!m) return null;
  const ex = m.extras || {};
  const g = ex.order_group != null ? ex.order_group : m.order_group;
  const i = ex.order_index != null ? ex.order_index : m.order_index;
  if (g == null || i == null || g === '' || i === '') return null;
  const gn = Number(g), inn = Number(i);
  if (!Number.isFinite(gn) || !Number.isFinite(inn)) return null;
  return { group: gn, index: inn };
}

/* 정렬 비교자 — 번호 있는 것 먼저 (group,index) 오름차순, 없는 것 뒤(uploaded_at 역순). */
export function compareByOrder(a, b) {
  const oa = getOrder(a), ob = getOrder(b);
  if (oa && ob) return (oa.group - ob.group) || (oa.index - ob.index);
  if (oa && !ob) return -1;
  if (!oa && ob) return 1;
  return String(b.uploaded_at || '').localeCompare(String(a.uploaded_at || ''));
}

/* 배열을 순서대로 정렬(불변 복사). */
export function sortByOrder(assets) {
  return [...(assets || [])].sort(compareByOrder);
}

/* g-i 부여 시 바뀌는 예제들의 새 번호 계산.
   codeAssets: 순서 대상 예제 배열(각 {id, extras|order_group/index, uploaded_at}).
   반환: { [id]: {group, index} } — 대상 포함, "실제로 바뀐" 것만. 다른 묶음은 불포함. */
export function computeReorder(codeAssets, targetId, targetGroup, targetIndex) {
  const G = Number(targetGroup);
  let I = Number(targetIndex);
  if (!Number.isFinite(G) || !Number.isFinite(I) || G < 1 || I < 1) return {};
  const changed = {};
  const target = (codeAssets || []).find((a) => a.id === targetId);
  if (!target) return {};
  const oldOrder = getOrder(target);
  const oldGroup = oldOrder ? oldOrder.group : null;

  // 묶음 g 의 현재 목록(대상 제외) — index 오름차순, 동률은 업로드순.
  const groupList = (g) => (codeAssets || [])
    .filter((a) => {
      if (a.id === targetId) return false;
      const o = getOrder(a);
      return o && o.group === g;
    })
    .sort((a, b) => (getOrder(a).index - getOrder(b).index)
      || String(a.uploaded_at || '').localeCompare(String(b.uploaded_at || '')));

  // 대상 묶음: 대상을 위치 I-1 에 삽입 → 1..N 연속 재부여(캐스케이드).
  const tg = groupList(G);
  let pos = I - 1;
  if (pos < 0) pos = 0;
  if (pos > tg.length) pos = tg.length;
  tg.splice(pos, 0, target);
  tg.forEach((a, k) => {
    const ni = k + 1;
    const cur = getOrder(a);
    if (!cur || cur.group !== G || cur.index !== ni) changed[a.id] = { group: G, index: ni };
  });

  // 옛 묶음(대상이 다른 묶음서 이동): 빈자리 메워 1..N 재압축.
  if (oldGroup != null && oldGroup !== G) {
    groupList(oldGroup).forEach((a, k) => {
      const ni = k + 1;
      if (getOrder(a).index !== ni) changed[a.id] = { group: oldGroup, index: ni };
    });
  }
  return changed;
}
